/** Retain existing devices when their shared power definition gains device-specific placement. */
export function resolveEloDefinitionPath(path: string): string {
  switch (path) {
    case "ventilation/fixedConsumer.power": return "ventilation/ventilation.power";
    case "airConditioningIndoor/fixedConsumer.power": return "airConditioningIndoor/airConditioningIndoor.power";
    case "airConditioningOutdoor/fixedConsumer.power": return "airConditioningOutdoor/airConditioningOutdoor.power";
    case "outdoorHeatPump/fixedConsumer400.power": return "outdoorHeatPump/outdoorHeatPump.power";
    default: return path;
  }
}
